function Hero() {
  return (
    <main>
      <h2>Welcome to Shopkart</h2>
      <p>Your one-stop online store</p>
      <div className="mt-4">
        <button>Shop Now</button>
      </div>
    </main>
  )
}

export default Hero
